import { render, staticRenderFns } from "./References.vue?vue&type=template&id=2f92ebf7&"
import script from "./References.vue?vue&type=script&lang=ts&"
export * from "./References.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports